import { Link } from 'react-router';
import { ArrowRight, Crosshair, Flag, Gauge, Trophy } from 'lucide-react';
import Eyebrow from '../ui/Eyebrow';
import ManagerAvatar from '../ui/ManagerAvatar';
import { managerSlug } from '../../utils/slug';
import { Reveal } from '../../motion';

export default function RecordsUnderAttack({ milestones = [] }) {
  if (!milestones.length) return null;
  return (
    <section className="px-6 md:px-14 py-14 border-b border-border bg-bg-deep" data-testid="records-under-attack">
      <Reveal>
        <Eyebrow color="red">ENTERING 2026</Eyebrow>
        <h2 className="mt-3 font-display font-black uppercase leading-[0.92] tracking-normal" style={{ fontSize: 'clamp(34px, 5vw, 72px)' }}>
          Records under <span className="text-accent-gold">attack.</span>
        </h2>
        <p className="mt-4 max-w-3xl text-sm md:text-base text-ink-secondary leading-relaxed italic">
          Personal finish lines derived from the validated career ledger through 2025. The targets move only when real 2026 results are published.
        </p>
      </Reveal>
      <Reveal delay={80} className="mt-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3">
        {milestones.map((item) => (
          <article key={item.manager} className="bg-bg-surface border-t-[3px] border-accent-gold p-5">
            <div className="flex items-center gap-3"><ManagerAvatar name={item.manager} size="sm" /><div><div className="text-lg font-black">{item.manager}</div><div className="text-[9px] tracking-[0.14em] text-ink-tertiary">#{item.pointsRank} LIFETIME PF</div></div></div>
            <Milestone icon={Flag} label="Next win marker" copy={item.winCopy} />
            <Milestone icon={Gauge} label="Points chase" copy={item.pointsCopy} />
            <Milestone icon={Crosshair} label="Playoff line" copy={item.playoffCopy} />
            <Milestone icon={Trophy} label="Ring pressure" copy={item.droughtCopy} />
            <Link to={`/managers/${managerSlug(item.manager)}`} className="mt-5 inline-flex items-center gap-1 text-[9px] font-black tracking-[0.16em] text-accent-gold">FULL CAREER <ArrowRight size={13} /></Link>
          </article>
        ))}
      </Reveal>
    </section>
  );
}

function Milestone({ icon: Icon, label, copy }) {
  return <div className="mt-4 border-t border-border pt-3"><div className="flex items-center gap-2 text-[9px] tracking-[0.14em] text-accent-gold font-black"><Icon size={13} />{label.toUpperCase()}</div><p className="mt-1.5 text-[11px] text-ink-secondary leading-relaxed italic">{copy}</p></div>;
}
